var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9927 18.9532H14.2984C13.7429 18.9532 13.291 19.4123 13.291 19.9766C13.291 20.5421 13.7429 21 14.2984 21H19.9927C20.5483 21 21.0001 20.5421 21.0001 19.9766C21.0001 19.4123 20.5483 18.9532 19.9927 18.9532Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.1203 8.66544L17.0801 9.96401C16.9753 10.0962 16.7869 10.1177 16.6568 10.0124C15.3922 8.98901 12.1541 6.36285 11.2556 5.63509C11.1244 5.52759 11.1064 5.33625 11.2122 5.20295L12.2154 3.95706C13.1255 2.78534 14.7128 2.67784 15.9933 3.69906L17.4642 4.87078C18.0674 5.34377 18.4695 5.96726 18.6071 6.62299C18.7658 7.3443 18.5965 8.0527 18.1203 8.66544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegist);
export default __webpack_public_path__ + "static/media/regist.7c7a3373cb07b6ab8b356d4fd890e2ff.svg";
export { ForwardRef as ReactComponent };